<template>
  <div class="home">
    <HeaderCharacterList/>
    <v-container>
      <div class="gallery" gutter=".gutter" transition-duration="0s" v-masonry fit-width="true">
        <GalleryPreview
          class="gallery-preview"
          v-masonry-tile
          v-for="(preview, character) in previews"
          :key="character" 
          :count="preview.count"
          :images="preview.images"
          :name="characters[character]"
          :id="character"
        />
        <div class="gutter"></div>
      </div>
      <p v-if="loaded && !Object.entries(previews).length">There is nothing here...</p>
    </v-container>
  </div>
</template>

<script>
import axios from '../plugins/axios'
import characters from '../enums/characters'
import HeaderCharacterList from '../components/HeaderCharacterList'
import GalleryPreview from '../components/GalleryPreview'

export default {
  components: {
    HeaderCharacterList,
    GalleryPreview
  },
  data: () => ({
    characters,
    previews: {},
    loaded: false
  }),
  async created () {
    const characterList = Object.keys(characters).join('+')
    const result = await axios.get(`/preview/${characterList}`)
    this.previews = Object.fromEntries(Object.entries(result.data.previews).filter(x => x[1].images.length))
    this.loaded = true
  }
}
</script>

<style scoped>
.gallery {
  margin: 0 auto;
}

.gallery-preview {
  margin-bottom: 25px;
}

.gutter {
  width: 25px;
}
</style>
